import { FieldArray, useFormikContext } from "formik";
import React, { FC, Fragment, useState } from "react";

import plusIcon from "../../../assets/addCircle.svg";
import { MAX_MEMBERS_FOR_CLUB } from "../../../common/constants/club.constants";
import {
  EMPTY_STRING,
  TOTAL_FEES,
} from "../../../common/constants/common.constants";
import { ADD_MEMBER_FEE } from "../../../common/constants/fees";
import { GovernanceConfigurationType } from "../../../common/enums/clubs-wizard.enum";
import { UserRole } from "../../../common/enums/common.enums";
import {
  ICreateClubWizardForm,
  ICreateClubWizardProps,
} from "../../../common/interfaces/clubs-wizard.interface";
import { removeItem } from "../../../utilities/helpers";
import Fees from "../../Fees/Fees";
import WizardHeader from "../WizardHeader/WizardHeader";

import "./ClubMembers.scss";
import MemberItem from "./MemberItem/MemberItem";
import MembershipRestriction from "./MembershipRestriction/MembershipRestriction";

const ClubMembers: FC<ICreateClubWizardProps> = ({ formFields }) => {
  const { values, setFieldValue } = useFormikContext<ICreateClubWizardForm>();
  const [maximumNumberOfMembersError, setMaximumNumberOfMembersError] =
    useState(EMPTY_STRING);

  //TODO@milica: check with product if this is maximum members for club or for fundraising in treasury
  const addMember = (arrayHelpers) => {
    if (values.initialMembers.length === MAX_MEMBERS_FOR_CLUB) {
      setMaximumNumberOfMembersError("Maximum number of members is 99.");
      return;
    }
    arrayHelpers.push({
      pubKey: "",
      role: values.investor ? UserRole.investor : UserRole.member,
    });
    setFieldValue(TOTAL_FEES, values.totalFees + ADD_MEMBER_FEE);
  };

  const removeMember = (index, arrayHelpers) => {
    if (
      arrayHelpers.form.values.initialMembers.length === MAX_MEMBERS_FOR_CLUB
    ) {
      setMaximumNumberOfMembersError(EMPTY_STRING);
    }
    removeItem(index, arrayHelpers);
    setFieldValue(TOTAL_FEES, values.totalFees - ADD_MEMBER_FEE);
  };

  return (
    <div className="club-members">
      <WizardHeader
        description={`Here you can add new ${
          values.governance === GovernanceConfigurationType.ProjectFundraise
            ? "participants"
            : "members"
        } and assign roles.`}
      />
      <FieldArray
        name={formFields.initialMembers.name}
        render={(arrayHelpers) => (
          <Fragment>
            {values.initialMembers.map((item, index) => (
              <MemberItem
                key={index}
                isOwner={item.role === UserRole.owner}
                index={index}
                field={formFields.initialMembers}
                removeItem={() => removeMember(index, arrayHelpers)}
              />
            ))}
            {maximumNumberOfMembersError !== EMPTY_STRING && (
              <p className="club-members__error">
                {maximumNumberOfMembersError}
              </p>
            )}
            <button onClick={() => addMember(arrayHelpers)} type="button">
              <img src={plusIcon} alt="Add new member" />
              {values.governance ===
              GovernanceConfigurationType.ProjectFundraise
                ? "Add new investor"
                : "Add new member"}
            </button>
            {/* TODO@milica-monke-merge: Monke does not have civic
            <MembershipRestriction /> */}
            <Fees
              feesTitle="Solana network fee for this action:"
              feesDescription={`${values.totalFees.toFixed(4)} SOL`}
            />
          </Fragment>
        )}
      />
    </div>
  );
};

export default ClubMembers;
